<template>
  <client-only>
    <v-form
      class="pt-7 pa-0 rtl mt-2"
      ref="formNew"
      v-model="valid"
      lazy-validation
    >
      <v-container pa-0>
        <v-layout wrap justify-space-between>
          <v-flex md6 xs12 class="p-relative">
            <NameField :formLabel="firstName" @newName="applyNewName" />
          </v-flex>
          <v-flex md6 xs12 class="p-relative">
            <NameField :formLabel="lastName" @newLastName="applyNewLastName" />
          </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between>
          <v-flex md6 xs12 class="p-relative">
            <EmailField
              @newEmail="applyNewEmail"
              @redirectToLogin="handleRedirect"
              @input="emailValidation = ''"
              :editable="true"
              :newToCheck="true"
              required
            />
          </v-flex>

          <v-flex md6 xs12 class="p-relative">
            <v-text-field
              v-model="emailValidation"
              outlined
              rounded
              :rules="emailValidationRules"
              type="text"
              label="הקלד שנית לצורך אימות"
              prepend-inner-icon="mdi-email-outline"
              ref="emailValidationField"
              required
              :disabled="!isEmailValid"
              @paste.prevent
              autocomplete="new-email"
              dense
              dir="auto"
            />
          </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between>
          <v-flex md6 xs12 class>
            <PasswordField
              @newPassword="applyNewPassword"
              :showRecoverLink="false"
            />
          </v-flex>

          <v-flex md6 xs12 class="p-relative" width="100%">
            <PhoneNumberField @updateNumber="applyNewPhone" />
          </v-flex>
        </v-layout>

        <v-layout wrap justify-space-between>
          <v-flex md6 xs12 class>
            <client-only>
              <LocationFieldNew @updateLocation="applyNewAddress" />
            </client-only>
          </v-flex>
        </v-layout>

        <v-layout column class>
          <v-flex xs12 class>
            <RememberMe />
          </v-flex>
          <v-flex xs12 class>
            <TermsField @newTerms="applyTerms" />
          </v-flex>
        </v-layout>

        <v-layout column wrap justify-center align-content-center>
          <v-flex text-center>
            <v-layout wrap justify-center>
              <v-flex text-xs-center>
                <v-btn
                  :disabled="!valid || !terms || showSpinner || !cityId"
                  :loading="process"
                  class="orange_btn_large"
                  @click="validateNewUser"
                  @keydown.enter="validateNewUser"
                >
                  הרשמה
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" max-width="320" persistent text-xs-center>
          <v-card>
            <v-card-title class="headline">ההרשמה בוצעה בהצלחה</v-card-title>

            <v-card-text class="display-36 text-xs-center" color="primary">
              <v-icon class="display-33 primary--text text-xs-center">
                mdi-check
              </v-icon>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" text @click="closeDialog">
                סגור
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-form>
  </client-only>
</template>

<script>
import { mapState } from 'vuex';
import EmailField from '@/components/Forms/Form_Fields/EmailField';
import PasswordField from '@/components/Forms/Form_Fields/PasswordField';
import NameField from '@/components/Forms/Form_Fields/NameField';
import TermsField from '@/components/Forms/Form_Fields/TermsField';
import RememberMe from '@/components/Forms/Form_Fields/RememberMe';
import LocationFieldNew from '@/components/Forms/Form_Fields/LocationFieldNew';
import PhoneNumberField from '@/components/Forms/Form_Fields/PhoneNumberField';
import CurrentUser from '@/components/mixins/CurrentUser';
import gtm from '@/lib/gtm';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import { SIGN_UP } from '@/lib/api.js';

export default {
  mixins: [CurrentUser],
  components: {
    EmailField,
    PasswordField,
    NameField,
    TermsField,
    RememberMe,
    LocationFieldNew,
    PhoneNumberField,
  },
  layout: 'innerPage',
  scrollToTop: false,

  props: {
    redirectBack: {
      type: Boolean,
      required: true,
      defalut: false,
    },
    page: {
      type: String,
      required: false,
      defalut: null,
    },
  },

  data() {
    return {
      dialog: false,
      process: false,
      valid: this.validation,
      alertError: '',
      UserExistsMessage: null,
      showSpinner: false,
      UserExists: false,
      rememberMe: false,
      lastNameNew: '',
      userNameNew: '',
      email: '',
      emailValidation: '',
      password: '',
      phoneNum: '', //undefined,
      cityId: null,
      terms: false,
      lastName: 'שם משפחה',
      firstName: 'שם פרטי',
      mainCat: undefined,
      mainCategory: null, // the selected cat from drop
      secondCatSelect: false,
      emailValidationRules: [(v) => !!v && this.checkEmailValidation()],
    };
  },

  computed: {
    isEmailValid() {
      return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.email);
    },
    ...mapState({
      allCategories: (state) => state.homeDrushim.allCategories,
    }),

    validation() {
      return this.userNameNew &&
        this.lastNameNew &&
        this.email &&
        this.password &&
        this.terms
        ? true
        : false;
    },
  },

  methods: {
    checkEmailValidation() {
      if (this.emailValidation.localeCompare(this.email)) {
        return t('titles.errorMessages.emailValidationFailed');
      } else {
        return true;
      }
    },
    /**
     * emits to parent to redirect registered user to login
     */
    handleRedirect(usersEmail) {
      this.$emit('moveToLogin', usersEmail);
    },

    resetFormNew() {
      this.$nuxt.$loading.finish();
      this.process = false;
    },
    closeDialog() {
      this.dialog = false;
      this.$router.push('/personal/myboard/');
    },

    applyNewName(name) {
      this.userNameNew = name;
    },

    applyNewLastName(name) {
      this.lastNameNew = name;
    },

    applyNewPhone(number) {
      this.phoneNum = number;
    },

    applyNewAddress(address) {
      this.cityId = address ? address.Code : null;
    },

    applyNewPassword(password) {
      this.password = password;
    },

    applyNewEmail(email) {
      this.email = email;
    },

    applyTerms(terms) {
      this.terms = terms;
    },

    applyMainCategory(category) {
      this.mainCategory = category.Code;
      this.mainCat = category;
    },

    async validateNewUser() {
      if (this.$refs.formNew.validate()) {
        const data = {
          FirstName: this.userNameNew,
          LastName: this.lastNameNew,
          AgreeToTerms: this.terms,
          Email: this.email,
          Password: this.password,
          RememberMe: this.rememberMe,
          CityId: this.cityId ? this.cityId : 1201,
          Phone: this.phoneNum,
          Source: this.page,
          FullSignUp: true,
        };

        try {
          this.process = true;
          const response = await this.$axios.post(`${SIGN_UP}`, data);

          if (response.data.IsError) {
            this.resetFormNew();
            throw 'כתובת דוא"ל לא תקינה';
          }

          gtm({
            ID: response.data.RegistrationSource.RegistrationIdentifier,
            registration: response.data.RegistrationSource.Source,
            event: 'leadcrmregistration',
          });

          this.$auth
            .loginWith('local', {
              data: {
                email: this.email,
                password: this.password,
              },
            })
            .then(() => {
              if (this.CurrentUser) {
                this.dialog = true;
                //emit an event to show cv box
                this.$emit('showCVForm');

                this.$router.push({
                  path: this.$route.fullPath,
                  query: { user_s: 'real_new' },
                });

                this.resetFormNew();
                if (this.redirectBack) {
                  setTimeout(() => {
                    this.$router.back();
                  }, 500);
                }
              } else {
                this.$toast.error('שגיאת התחברות ');
              }
            });
        } catch (e) {
          this.$toast.error(e);
          this.resetFormNew();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div.v-input__slot {
  border-radius: 50px;
  border-color: red;
}

.term-page {
  font-size: 14px;
}

.v-messages__message {
  padding: 10px 2px !important;
  font-size: 12px !important;
}
</style>
